<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'FORMS_TEMPLATES_MODULE.TEMPLATE.TEMPLATES_LIST' | translate"
    [viewLoading$]="dataSource?.loading$"
    [class]="'card-head-lg'"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddDocumentTemplate">
          <button mat-raised-button class="btn btn-primary" (click)="addTemplate($event)">
            <span
              inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>{{ 'FORMS_TEMPLATES_MODULE.TEMPLATE.ADD_TEMPLATE' | translate }}</span>
          </button>
        </ng-template>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <button
          style="width: 175px !important"
          class="btn btn-sm btn-light-{{ getStatusClass(searchIsActiveSelect?.value) }} mr-4"
          (click)="toggleIsActive($event)"
        >
          {{ getStatusLabel(searchIsActiveSelect?.value) }} Templates
        </button>
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FORMS_TEMPLATES_MODULE.TEMPLATE.ID' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let template">{{ template.id }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchId">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FORMS_TEMPLATES_MODULE.TEMPLATE.ID' | translate }}</mat-label>
              <input
                matInput
                #searchIdInput
                [placeholder]="'FORMS_TEMPLATES_MODULE.TEMPLATE.ID' | translate"
              />
              <button
                *ngIf="searchIdInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchIdInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FORMS_TEMPLATES_MODULE.TEMPLATE.NAME' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let template">
            <span
              [matTooltip]="canViewTemplate() ? 'View Template' : null"
              [class.clickable]="canViewTemplate()"
              (dblclick)="viewTemplate($event, template)"
              >{{ formatName(template.name) }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FORMS_TEMPLATES_MODULE.TEMPLATE.NAME' | translate }}</mat-label>
              <input
                matInput
                #searchNameInput
                [placeholder]="'FORMS_TEMPLATES_MODULE.TEMPLATE.NAME' | translate"
              />
              <button
                *ngIf="searchNameInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchNameInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>

        <ng-container matColumnDef="createdBySuperAdmin">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FORMS_TEMPLATES_MODULE.TEMPLATE.ORIGIN' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let template">
            <div
              class="ks-badge-md ks-badge-light-{{
                template.created_by_super_admin ? 'secondary' : 'neutral'
              }}"
            >
              {{ template.created_by_super_admin ? 'Global' : 'Company' }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchOrigin">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FORMS_TEMPLATES_MODULE.TEMPLATE.ORIGIN' | translate }}</mat-label>
              <mat-select
                #searchOriginSelect
                [placeholder]="'FORMS_TEMPLATES_MODULE.TEMPLATE.ORIGIN' | translate"
              >
                <mat-option *ngFor="let origin of originOptions" [value]="origin.value">{{
                  origin.label
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>

        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'FORMS_TEMPLATES_MODULE.TEMPLATE.STATUS' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let template">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getStatusClass(template.is_active?.toString())
              }} label-inline text-center"
            >
              {{ getStatusLabel(template.is_active?.toString()) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsActive">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'FORMS_TEMPLATES_MODULE.TEMPLATE.STATUS' | translate }}</mat-label>
              <mat-select
                #searchIsActiveSelect
                [placeholder]="'FORMS_TEMPLATES_MODULE.TEMPLATE.STATUS' | translate"
                (selectionChange)="handleIsActiveChange()"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let template">
            <ng-template ngxPermissionsOnly="canViewDocumentTemplate">
              <button
                matTooltip="{{ 'TABLE.VIEW' | translate }} Template"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewTemplate($event, template)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canEditDocumentTemplate">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Template"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="updateTemplate($event, template)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canActivateDocumentTemplate">
              <button
                matTooltip="{{ 'TABLE.ACTIVATE_DEACTIVATE' | translate }} Template"
                class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
                (click)="toggleTemplateStatus($event, template)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/update_icon2.svg"
                  class="svg-icon svg-icon-md svg-icon-warning"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedCols" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarCols"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedCols"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
